<mat-form-field appearance="outline" hideRequiredMarker>
  <mat-label>{{ passwordLabel }}</mat-label>
  <input
    matInput
    type="password"
    [name]="passwordFieldName"
    [formControl]="passwordControl"
    [minlength]="minPasswordLength"
    autocomplete="new-password"
    data-cy="new-password"
    required
  />
  <mat-icon
    matSuffix
    *ngIf="passwordState?.allowed"
    svgIcon="check-circle"
    [ngClass]="passwordState.level"
  ></mat-icon>
</mat-form-field>

<mat-form-field appearance="outline" hideRequiredMarker>
  <mat-label>{{ retypedPasswordLabel }}</mat-label>
  <input
    matInput
    #retypedPasswordInput="matInput"
    type="password"
    [name]="retypedPasswordFieldName"
    [formControl]="retypePasswordControl"
    data-cy="retyped-password"
    autocomplete="off"
    required
    (keyup.enter)="passwordEnter()"
  />
  <mat-icon
    matSuffix
    *ngIf="passwordState?.allowed && !retypePasswordControl.invalid"
    svgIcon="check-circle"
    [ngClass]="passwordState.level"
  ></mat-icon>
  <mat-error matSuffix *ngIf="retypedPasswordInput.errorState && passwordNotMatchErrorVisible"
    >Oops! Password doesn't match</mat-error
  >
</mat-form-field>

<lgn-password-state
  *ngIf="passwordState.level"
  [@EnterLeave]="'flyIn'"
  [state]="passwordState"
></lgn-password-state>
